import React from "react";

const PracticeVideo = () => {
  return (
    <>
      <div id="Video" className="relative bg-white flex justify-center">
        <div className="w-full max-w-7xl flex flex-col items-center justify-center px-5 py-12 sm:py-0">
          <div className="text-center">
            <p className="text-4xl font-bold text-black">
              Software Tutorial<span className="text-[#74dab6]">'s</span>
            </p>
          </div>
          <div className="grid sm:grid-cols-4 grid-cols-1 sm:grid-rows-3 gap-3 w-[100%] sm:h-[70%]">
            <div className="sm:col-span-3 sm:row-span-2 p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/Oim0RWXvQ7A"
                  frameborder="0"
                  className="h-full w-full"
                  title="FirstVideo"
                ></iframe>
              </div>

              <p className="p-1">EasyGST Tutorial</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/VOqO3taT5PM"
                  frameborder="0"
                  className="h-full w-full"
                  title="SecVideo"
                ></iframe>
              </div>
              <p className="p-1">Multi-Angle Analysis</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/fGSkTy4_LwA"
                  frameborder="0"
                  className="h-full w-full"
                  title="ThirdVideo"
                ></iframe>
              </div>
              <p className="p-1">GSTR-2B & GSTR-2A</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/_LSFcd-mKf4"
                  frameborder="0"
                  className="h-full w-full"
                  title="FourthVideo"
                ></iframe>
              </div>
              <p className="p-1">Preparation of GSTR-1</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/CowaP0niJ6U"
                  frameborder="0"
                  className="h-full w-full"
                  title="FivethVideo"
                ></iframe>
              </div>
              <p className="p-1">Preparation of GSTR-3B</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/mMXy83jxE-Q"
                  frameborder="0"
                  className="h-full w-full"
                  title="SixthVideo"
                ></iframe>
              </div>
              <p className="p-1">GST Annual Return - GSTR 9</p>
            </div>
            <div className=" p-5 pb-7 border-2 border-[#7decc6] rounded-xl text-center shadow-xl">
              <div className="h-full w-full">
                <iframe
                  src="https://www.youtube.com/embed/rR3w7yR-_1k"
                  frameborder="0"
                  className="h-full w-full"
                  title="SevenVideo"
                ></iframe>
              </div>
              <p className="p-1">Returns CMP-08 & GSTR-4</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PracticeVideo;
